// Where a user lands after signing in when they weren't deep-linking anywhere.
// Kept in one place so the login screen and any future landing-page handshake
// can't drift apart.
export const DEFAULT_LANDING_ROUTE = '/dashboard';
